import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Header,
  HeroSection,
  AboutSection,
  ServicesSection,
  ProcessSection,
  WhoWeServeSection,
  ProductsSection,
  WhyChooseSection,
  BrandsSection,
  TeamSection,
  FaqSection,
  HOME_FAQ,
  ContactSection,
  Footer,
  WhatsAppButton
} from '../components/sections';
import { useHeadTags } from '../hooks/useHeadTags';

const Home = () => {
  useHeadTags({
    title: "Italian Food Export Company & Supplier | ALL-FOOD",
    description: "Italian food export company and supplier in Tuscany. We source, quality-check and ship pasta, cheese, olive oil and cured meats to importers worldwide.",
    canonical: "https://www.all-food.it/",
    ogTitle: "Italian Food Export Company & Supplier | ALL-FOOD",
    ogDescription: "Italian food export company and supplier in Tuscany. We source, quality-check and ship pasta, cheese, olive oil and cured meats to importers worldwide.",
    ogUrl: "https://www.all-food.it/",
    ogType: "website",
    ogImage: "https://www.all-food.it/api/img/about-tuscany-og.jpg",
    twitterCard: "summary_large_image",
    twitterTitle: "Italian Food Export Company & Supplier | ALL-FOOD",
    twitterDescription: "Italian food export company and supplier in Tuscany. We source, quality-check and ship pasta, cheese, olive oil and cured meats to importers worldwide.",
    twitterImage: "https://www.all-food.it/api/img/about-tuscany-og.jpg",
    alternates: [
      { hrefLang: "en", href: "https://www.all-food.it/" },
      { hrefLang: "x-default", href: "https://www.all-food.it/" },
      { hrefLang: "de", href: "https://www.all-food.it/de/italienische-lebensmittel-grosshandel" },
    ],
  });
  const location = useLocation();

  useEffect(() => {
    const scrollTo = location.state?.scrollTo;
    if (scrollTo) {
      // Small delay to let the DOM render before scrolling
      setTimeout(() => {
        document.getElementById(scrollTo)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      // Clear the state so back-navigation doesn't re-scroll
      window.history.replaceState({}, '');
    }
  }, [location.state]);
  return (
    <div className="min-h-screen bg-white">
      <>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": HOME_FAQ.map((item) => ({
            "@type": "Question",
            "name": item.q,
            "acceptedAnswer": { "@type": "Answer", "text": item.a }
          }))
        })}</script>
      </>

      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProcessSection />
        <WhoWeServeSection />
        <ProductsSection />
        <WhyChooseSection />
        <BrandsSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
